export const ADD_FAV = 'ADD_FAV'; 
export const REMOVE_FAV = 'REMOVE_FAV';
export const FILTER = 'FILTER';
export const ORDER = 'ORDER';
// export const SET_ACCES = 'SET_ACCES';